module.exports = __webpack_public_path__ + "3572c8397075b751e974955eae8f2747.png";